export default "__VITE_ASSET__CmxmJ4ia__"